<ion-content scrollEvents="true" (ionScroll)="onScroll($event)" #content>
  <div class="sb-sticky">
    <sb-simple-navbar [hasBackButton]="true">
      <h4 class="sb-back--title color-light">{{ sportbookFacade.selectedRace }}</h4>
    </sb-simple-navbar>

    <ng-container *ngIf="videoActivated">
      <div
        class="streaming-button-container background-color-regular border-color-regular"
        tappable
        (click)="switchVideo()"
        *ngIf="!showingVideo"
      >
        <a class="streaming-button-container--button streaming-button-container--title color-secondary"> {{ 'Video Live' }} </a>
      </div>

      <div
        *ngIf="showingVideo"
        id="video-container"
        class="sb-grid-layout video-container-race-market sb-grid-layout--item background-color-base"
      ></div>
    </ng-container>

    <sb-grid-filter
      [currentEvent]="race$ | async"
      (select)="toggle($event)"
      [isRace]="true"
      [bgColor]="'background-color-light'"
      [currentPage]="'race-market'"
      [blocked]="dropListEventsBlocked$ | async"
    >
      <sb-prematch-item
        *ngFor="let league of dropListEvents$ | async"
        [item]="league"
        imageURL="assets/global/img/banderas/ICO_{{ league?.CountryCode }}.png"
        [title]="league?.Name"
        [arrow]="false"
        [subtitle]="league?.StartDate | sportsExtractHour"
        [item]="league"
        (navigate)="navigate($event)"
      >
      </sb-prematch-item>
    </sb-grid-filter>
    <sb-tabs
      *ngIf="filters?.length"
      [categories]="filters"
      [color]="'regular'"
      [selectedTab]="currentFilter$ | async"
      (selectTab)="filter($event)"
    ></sb-tabs>
  </div>

  <ion-list *ngIf="participants$ | async as participants" class="has-no-padding race-market-list" no-margin>
    <sb-grid-header [headerTitles]="header$ | async" mode="thumbnail" [currentPage]="'race-market'"></sb-grid-header>
    <sports-grid
      *ngFor="let participant of participants; let i = index; trackBy: utils?.trackBy"
      mode="thumbnail"
    >
      <sb-grid-content-thumbnail
        content
        [title]="participant?.Name"
        [text]="participant?.JockeyName"
        [startDate]="(race$ | async)?.StartDate"
        [jockeyColors]="participant?.JockeyColours"
        [cloth]="(race$ | async)?.SportHandle === 'horse_racing' ? participant?.Cloth : participant?.Trap"
        [sport]="(race$ | async)?.SportHandle"
        [position]="i + 1"
        [countryCode]="(race$ | async)?.CountryCode"
        [defaultURL]="globalVars?.URLBASE"
      >
      </sb-grid-content-thumbnail>
      <div
        *ngIf="currentFilter$ | async as currentFilter"
        [ngSwitch]="currentFilter?.navigate"
        [ngClass]="raceBets"
        class="sports-grid--race-bets"
        race-button
      >
        <!-- GANADOR FILTER -->
        <ng-container *ngSwitchCase="'win'">
          <button
            [disabled]="_race?.WinDisabled || isHorseRaceUSA ? true : null"
            [ngClass]="{'is-selected': newTicketFacade?.hasResult(participant.NodeId, 1, true, true)}"
            class="sports-button background-color-button border-color-button"
            [hidden]="participant.Odd === -1 || participant.IsNonRunner"
            (click)="betResult($event, participant, 1, false)"
          >
            <p class="sb-button--subtitle color-dark">{{ participant.Odd | sportsFormatOdd }}</p>
          </button>

          <button
            [disabled]="race?.WinDisabled"
            [ngClass]="{'is-selected': newTicketFacade?.hasResult(participant.NodeId, 1, false, true)}"
            class="sports-button background-color-button border-color-button"
            (click)="betResult($event, participant, 1, true)"
          >
            <p class="sb-button--subtitle color-dark">
              <span>CF</span>
            </p>
          </button>

          <button
            [ngClass]="{'is-selected': newTicketFacade?.hasResult(participant.NodeId, 2, false, true)}"
            [disabled]="race?.PlaceDisabled"
            class="sports-button background-color-button border-color-button"
            (click)="betResult($event, participant, 2, true)"
          >
            <p class="sb-button--subtitle color-dark">
              <span>GC</span>
            </p>
          </button>
        </ng-container>

        <!-- GEMELAS FILTER -->
        <ng-container *ngSwitchCase="'forecast'">
          <button
            class="sports-button background-color-button border-color-button"
            [ngClass]="{ 'is-selected': bets[0] && bets[0][i] }"
            (click)="addMulticastSelection($event,participant, 0, i)"
            [disabled]="
                      (bets[0] && !bets[0][i] && !colEnabled[0]) ||
                      (bets[0] && (bets[1][i] || bets[2][i]))
                    "
          >
            <p class="sb-button--subtitle color-dark">1º</p>
          </button>
          <button
            class="sports-button background-color-button border-color-button"
            [ngClass]="{ 'is-selected': bets[1] && bets[1][i] }"
            (click)="addMulticastSelection($event,participant, 1, i)"
            [disabled]="
                      (bets[1] && !bets[1][i] && !colEnabled[1]) ||
                      (bets[0] && (bets[0][i] || bets[2][i]))
                    "
          >
            <p class="sb-button--subtitle color-dark">2º</p>
          </button>
          <button
            class="sports-button background-color-button border-color-button"
            [ngClass]="{ 'is-selected': bets[2] && bets[2][i] }"
            (click)="addMulticastSelection($event,participant, 2, i)"
            [disabled]="bets[2] && !bets[2][i] && !colEnabled[2]"
          >
            <p class="sb-button--subtitle color-dark">{{ 'tOther' | translate }}</p>
          </button>
        </ng-container>

        <!-- TRIOS FILTER -->
        <ng-container *ngSwitchCase="'tricast'">
          <button
            class="sports-button background-color-button border-color-button"
            [ngClass]="{ 'is-selected': bets[0] && bets[0][i] }"
            (click)="addMulticastSelection($event,participant, 0, i)"
            [disabled]="
                      (bets[0] && !bets[0][i] && !colEnabled[0]) ||
                      (bets[0] && (bets[1][i] || bets[2][i]))
                    "
          >
            <p class="sb-button--subtitle color-dark">1º</p>
          </button>
          <button
            class="sports-button background-color-button border-color-button"
            [ngClass]="{ 'is-selected': bets[1] && bets[1][i] }"
            (click)="addMulticastSelection($event,participant, 1, i)"
            [disabled]="
                      (bets[1] && !bets[1][i] && !colEnabled[1]) ||
                      (bets[0] && (bets[0][i] || bets[2][i]))
                    "
          >
            <p class="sb-button--subtitle color-dark">2º</p>
          </button>
          <button
            class="sports-button background-color-button border-color-button"
            [ngClass]="{ 'is-selected': bets[2] && bets[2][i] }"
            (click)="addMulticastSelection($event,participant, 2, i)"
            [disabled]="
                      (bets[2] && !bets[2][i] && !colEnabled[2]) ||
                      (bets[0] && (bets[0][i] || bets[1][i]))
                    "
          >
            <p class="sb-button--subtitle color-dark">3º</p>
          </button>
          <button
            class="sports-button background-color-button border-color-button"
            [ngClass]="{ 'is-selected': bets[3] && bets[3][i] }"
            (click)="addMulticastSelection($event,participant, 3, i)"
            [disabled]="bets[3] && !bets[3][i] && !colEnabled[3]"
          >
            <p class="sb-button--subtitle color-dark">{{ 'tOther' | translate }}</p>
          </button>
        </ng-container>
      </div>
    </sports-grid>
  </ion-list>

  <!-- GEMELA/TRIO BETTING BUTTONS -->
  <div class="horses-bets-footer" [ngClass]="{'is-desktop': isDesktop, 'is-mobile': !isDesktop}" [hidden]="!canBet">
    <ion-toolbar position="bottom" class="toolbar-bottom-group background-color-dark">
      <ion-row [ngStyle]="{'flex-direction': !isDesktop ? 'column-reverse' : 'row'}">
        <ion-col class="styleBottom" [ngStyle]="{'display': !isDesktop ? 'none' : 'block'}" size="8"></ion-col>
        <ion-col size-xl="3" size-xs="12">
          <button ion-button full (click)="resetBet()" class="is-ticket-button reset">
            <span class="text-center"> {{ 'tCleanSel' | translate }} </span>
          </button>
        </ion-col>
        <ion-col size-xl="3" size-xs="12">
          <button ion-button full (click)="betMulticast()" class="is-ticket-button send">
            <span class="text-center"> {{ 'tAddTick' | translate }} </span>
          </button>
        </ion-col>
      </ion-row>
    </ion-toolbar>
  </div>

  <codere-footer></codere-footer>
</ion-content>
